import type { ReactNode } from 'react';

import { Sparkline } from '@/components/common/sparkline';
import { Card, CardContent } from '@/components/ui/card';

interface StatTileProps {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  /** Sparkline points — when provided, renders an inline trend line. */
  spark?: number[];
  /** Stroke colour for the sparkline. */
  accent?: string;
  /** Optional leading icon next to the label. */
  icon?: ReactNode;
}

/** A single KPI tile: uppercase label, large tabular value, optional trend. */
export function StatTile({ label, value, sub, spark, accent, icon }: StatTileProps): JSX.Element {
  return (
    <Card>
      <CardContent className="pt-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {icon}
              {label}
            </p>
            <p className="mt-1 text-2xl font-semibold tabular-nums">{value}</p>
            {sub && <p className="mt-0.5 text-xs text-muted-foreground">{sub}</p>}
          </div>
          {spark && <Sparkline points={spark} color={accent} />}
        </div>
      </CardContent>
    </Card>
  );
}
